'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var constants = require('../../constants.js');
var useDefaultInternalState = require('../useDefaultInternalState.js');
var utils = require('./utils.js');

// animation duration in milliseconds
var ANIMATION_DURATION = 250;
var useExpander = function (_a) {
    var _b = _a === void 0 ? {} : _a, 
    /**
     * True if expander functionality should be suppressed. False otherwise.
     */
    _c = _b.disable, 
    /**
     * True if expander functionality should be suppressed. False otherwise.
     */
    disable = _c === void 0 ? false : _c, 
    /**
     * True if the panel is expanded. False otherwise.
     */
    _d = _b.expanded, 
    /**
     * True if the panel is expanded. False otherwise.
     */
    expanded = _d === void 0 ? false : _d, 
    /**
     * The minimum height for which an element should be set. This value must be a number of pixels
     */
    _e = _b.minHeight, 
    /**
     * The minimum height for which an element should be set. This value must be a number of pixels
     */
    minHeight = _e === void 0 ? 0 : _e, 
    /**
     * Setter for expanded
     */
    setExpanded = _b.setExpanded;
    var ref = react.useRef(null);
    var isFirstRun = react.useRef(true);
    var _f = useDefaultInternalState.default(expanded, setExpanded), internalExpanded = _f[0], setInternalExpanded = _f[1];
    var toggle = react.useCallback(function (newExpanded) {
        if (newExpanded !== undefined && newExpanded !== null) {
            setInternalExpanded(!!newExpanded);
        }
        else {
            setInternalExpanded(function (previous) { return !previous; });
        }
    }, [setInternalExpanded]);
    react.useLayoutEffect(function () {
        var _a;
        if (!disable && isFirstRun.current === true && ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.style)) {
            ref.current.style.height = internalExpanded ? 'auto' : "".concat(minHeight, "px");
            ref.current.style.overflow = internalExpanded ? 'visible' : 'hidden';
        }
    }, [disable, internalExpanded, minHeight]);
    react.useEffect(function () {
        var _a, _b;
        if (disable) {
            return;
        }
        var timeout;
        if (!isFirstRun.current && ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.style)) {
            var scrollHeight = (_b = ref.current.scrollHeight) !== null && _b !== void 0 ? _b : minHeight;
            if (internalExpanded) {
                ref.current.style.height = "".concat(scrollHeight, "px");
                timeout = setTimeout(function () {
                    var _a;
                    if ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.style) {
                        ref.current.style.height = 'auto';
                        ref.current.style.overflow = 'visible';
                    }
                }, ANIMATION_DURATION);
            }
            else {
                ref.current.style.height = "".concat(scrollHeight, "px");
                timeout = setTimeout(function () {
                    var _a;
                    if ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.style) {
                        ref.current.style.height = "".concat(minHeight, "px");
                        ref.current.style.overflow = 'hidden';
                    }
                }, 50); // 50 ms seems to be the right amount of time to wait here. Any less and the UI doesn't pickup the close transition sometimes.
            }
        }
        isFirstRun.current = false;
        return function () { return clearTimeout(timeout); };
    }, [disable, internalExpanded, minHeight]);
    react.useEffect(function () {
        if (disable) {
            return;
        }
        var setTabIndexes = function () {
            var node = ref.current;
            var focusableContent = node
                ? node.querySelectorAll(constants.ALL_FOCUSABLE_SELECTOR)
                : [];
            focusableContent.forEach(function (childElement) {
                var isTabbable = internalExpanded || utils.isVisible(node, childElement);
                var newTabIndex = isTabbable ? 0 : -1;
                utils.setTabIndex(childElement, newTabIndex);
            });
        };
        // Wait for the amount of time the animation takes so offsets wille be accurate
        var timeout = setTimeout(setTabIndexes, ANIMATION_DURATION);
        return function () { return clearTimeout(timeout); };
    }, [disable, internalExpanded]);
    return {
        isExpanded: internalExpanded,
        toggle: toggle,
        ref: ref
    };
};

exports.useExpander = useExpander;
//# sourceMappingURL=useExpander.js.map
